import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import FilterListIcon from '@mui/icons-material/FilterList';
import Checkbox from '@mui/material/Checkbox';
import TableSortLabel from '@mui/material/TableSortLabel';
import Box from '@mui/material/Box';
import { visuallyHidden } from '@mui/utils';
import TablePagination from '@mui/material/TablePagination';
import AddIcon from '@mui/icons-material/Add';
import BasicModal from './modal';
import BasicModalInviteInsert from './modal';
import Modal from "@mui/material/Modal";
import { Button } from '@mui/material';
import { API } from '@aws-amplify/api';
import RedoIcon from '@mui/icons-material/Redo';
import UserInfoForm from '../Forms/userinfoform';

const headCells = [
    {
      id: 'email',
      numeric: false,
      disablePadding: false,
      label: 'email address',
    },
    {
      id: 'time_since',
      numeric: false,
      disablePadding: false,
      label: 'time since invite',
    },
    {
      id: 'sent_date',
      numeric: true,
      disablePadding: false,
      label: 'sent on date',
    },
    {
      id: 'sent_status',
      numeric: true,
      disablePadding: false,
      label: 'sent status',
    }
    
];

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function openModalInvite() {
  console.log('here in open modal invite');
  <BasicModal />
}

function EnhancedTableToolbar(props) {
  const { numSelected } = props;
  const { selectedList } = props;
  const [modalOpen, setModalOpen] = React.useState(false);
  const [modalConfirmOpen, setModalConfirmOpen] = React.useState(false);
  const [tooltipInsertOpen, setTooltipInsertOpen] = React.useState(false);
  const [tooltipDeleteOpen, setTooltipDeleteOpen] = React.useState(false);
  const [value, setValue] = useState(""); 
  const [result, setResult] = useState(""); 

  console.log('props into enh-table-toolbar',props);



  function doInviteAdd(invitee) {  
    console.log('here in tooltip open',invitee);
    handleModalClose();
    
  }

  async function insertInviteAsync(emailList) {
    console.log('starting the insert with insert list like', emailList);
    var cleaned = emailList.replace(/\s/g,'')
    var email_list = cleaned.split(",");
    var post_body = {"emailList":email_list}
    //var post_body = {"emailList":emailList}
    console.log('post body var is ', post_body);
    var len_list = email_list.length;
    console.log('lenis', len_list);

    console.log('using post_body',post_body);    
    const apiName = 'apic48d2c9b' // 'api60cb0321';
    const path = '/invite';
    const myInit = {
      body: post_body, // replace this with attributes you need
      headers: {} // OPTIONAL
    };
    API.post(apiName, path, myInit)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error.response)
      return error.response;
    })
  }

  function handleTooltipInsertOpen() {  
    setTooltipInsertOpen(true);
  }

  function handleTooltipInsertClose() {
    console.log('here in tooltip close');
    setTooltipInsertOpen(false);
    //setModalOpen(false);
  }

  function handleTooltipDeleteOpen() {  
    setTooltipDeleteOpen(true);
    setModalConfirmOpen(true);
  }

  function handleTooltipDeleteClose() {
    setTooltipDeleteOpen(false);
    //setModalOpen(false);
  }

  function handleModalOpen() {
    console.log('here in modal open');
    //settooltipOpen(false);
    setModalOpen(true);
  }

  function handleModalClose() {
    console.log('here in tooltip close');
    //settooltipOpen(false);
    setModalOpen(false);
  }

  function handleModalConfirmOpen() {
    setModalConfirmOpen(true);
  }

  function handleModalConfirmClose() {
    setModalConfirmOpen(false);
  }

  const toggleClick = (index) => {
    console.log("aaaaaaaaa");
    handleModalClose();

  };

  const toggleConfirmClick = (index) => {
    console.log("bbbbb");
    handleModalConfirmClose();
  };

  async function handleInsertSubmit(e) { 
    e.preventDefault(); 
    const response = await insertInviteAsync(value);
    setResult("Form has been submitted with with Input: " + value  + " and returned response " + response); 
  } 

  function handleChange(e) { 
    setValue(e.target.value); 
    setResult(""); 
  } 
  
  function handleDeleteSet(deleteList) {
    console.log('delete size', deleteList.length)
    console.log('delete list:',  deleteList)
  }

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} Invites selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          No invites selected
        </Typography>
      )}

      {numSelected > 0 ? (
        <>
        <Tooltip title="Delete" open={tooltipDeleteOpen} onOpen={handleTooltipDeleteOpen}  onClose={handleTooltipDeleteClose}  >
          <IconButton >
            <DeleteIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title="Send again"  >
        <IconButton>
          <RedoIcon />
        </IconButton>
        </Tooltip>
        <Modal
            open={modalConfirmOpen}
            onClose={handleModalConfirmClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            >
              
            <Box sx={style}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Are you sure you want to delete {numSelected}  records?
                {selectedList}
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                <Button
                  style={{ width: 20, height: 20, padding: 20 }}
                  onClick={() => toggleConfirmClick(2)}
                >
                 YES
              </Button> 
              <Button>CANCEL</Button>              
              </Typography>
              <Button></Button>
            <div> 
                <h4>{result}</h4> 
            </div> 
            </Box>
          </Modal>
        </>


      ) : (
        <>
          <Tooltip title="Add Invite" open={tooltipInsertOpen} onClose={handleTooltipInsertClose} onOpen={handleTooltipInsertOpen} onClick={handleModalOpen}>
            <IconButton>           
              <AddIcon />
            </IconButton>
          </Tooltip>

          <Modal
            open={modalOpen}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            >
              
            <Box sx={style}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Edit Invitee List Details
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
       
                <Button
                  style={{ width: 20, height: 20, padding: 20 }}
                  onClick={() => toggleClick(2)}
                >
                  CLOSE
              </Button>    
              <UserInfoForm />           
              </Typography>
              <Button></Button>

              <form onSubmit={handleInsertSubmit}> 
                <label>Add email addresses here </label> 
                <input 
                    value={value} 
                    onInput={handleChange} 
                    required 
                /> 
                <br /> 
                <br /> 
                <button type="submit">Invite</button> 
            </form> 
            <div> 
                <h4>{result}</h4> 
            </div> 
            </Box>
          </Modal>
        </>
      )}
    </Toolbar>
  );
}
  
EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
  selectedList: PropTypes.array.isRequired
};

function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              'aria-label': 'select all desserts',
            }}
          />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default function  InvitationList ({invitations, handleDelete})  {

    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('email');
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [dense, setDense] = React.useState(true);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    //const [listChanged, setlistChanged] = useState(invitations);

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - invitations.length) : 0;

    const handleClick = (event, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];
    
        if (selectedIndex === -1) {
          newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
          newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
          newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
          newSelected = newSelected.concat(
            selected.slice(0, selectedIndex),
            selected.slice(selectedIndex + 1),
          );
        }
        setSelected(newSelected);
    };
    
    const handleSelectAllClick = (event) => {
      if (event.target.checked) {
        const newSelected = invitations.map((n) => n.invitee_email.S);
        setSelected(newSelected);
        return;
      }
      setSelected([]);
    };

    const handleRequestSort = (event, property) => {
      console.log('proper to sort on' + property)
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
  
    const handleChangeDense = (event) => {
      setDense(event.target.checked);
    };

    const visibleRows = React.useMemo(
      () =>
        stableSort(invitations, getComparator(order, orderBy)).slice(
          page * rowsPerPage,
          page * rowsPerPage + rowsPerPage,
        ),
      [invitations, order, orderBy, page, rowsPerPage],
    );

    const isSelected = (id) => selected.indexOf(id) !== -1;

    function preHandleDelete(id) {
        invitations = invitations.filter(invites => invites.invitee_email.S !== id)
        console.log('now filtered..invitiations become', invitations);
        //setlistChanged(invitations);
        handleDelete(id);
    }

    console.log('InvitationList invitations',invitations);
    // invitations = listChanged;
    return (
      <>
      <Box sx={{ width: '100%' }}>
        <Paper sx={{ width: '100%', mb: 2 }}>
          <EnhancedTableToolbar numSelected={selected.length} selectedList={selected}/>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
              <EnhancedTableHead
                      numSelected={selected.length}
                      order={order}
                      orderBy={orderBy}
                      onSelectAllClick={handleSelectAllClick}
                      onRequestSort={handleRequestSort}
                      rowCount={invitations.length}
              />
              <TableBody>
                {visibleRows.map((row, index) => {
                  const isItemSelected = isSelected(row.invitee_email.S);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  console.log('viz is',row);
                  return (
                    <TableRow
                      hover
                      onClick={(event) => handleClick(event, row.invitee_email.S)}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.invitee_email.S}
                      selected={isItemSelected}
                      sx={{ cursor: 'pointer' }}
                    >  
                      <TableCell padding="checkbox">
                        <Checkbox color="primary" checked={isItemSelected} inputProps={{'aria-labelledby': labelId,}} />              
                      </TableCell>
                      <TableCell scope="row" align="left">{row.invitee_email.S}</TableCell>
                      <TableCell scope="row" align="left">{row.invitee_email.S}</TableCell>
                      <TableCell scope="row" align="left">sent result here</TableCell>
                    </TableRow>    );          
                  })}              
                  {emptyRows > 0 && (
                    <TableRow
                      style={{
                        height: (dense ? 33 : 53) * emptyRows,
                      }}
                    >
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
          </TableContainer> 
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={invitations.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
      </Paper>      
      </Box>
    </>
    );
}

